import { inject } from 'mobx-react';
import * as React from 'react';
import { AnsweringTravellerQuestionsContentSearch } from '@shared-ui/retail-product-answering-traveller-questions';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { IdentifierType } from '__generated__/api';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
const AnsweringTravellerQuestionsWrapper = inject('currentHotel', 'context')(({
  currentHotel,
  context
}) => {
  var _a;
  if (currentHotel && currentHotel.hotelId) {
    const propertySearchCriteria = context && adaptSearchCriteria(context, currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.searchCriteria);
    return React.createElement(Experiment, {
      name: "QnA_using_Reviews_and_Property_Content_Gen_AI_Feature_Gate"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(AnsweringTravellerQuestionsContentSearch, {
      inputs: {
        productIdentifier: {
          id: (_a = currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.hotelId) === null || _a === void 0 ? void 0 : _a.toString(),
          type: IdentifierType.PROPERTY_ID,
          travelSearchCriteria: {
            property: propertySearchCriteria
          }
        }
      },
      skipSsr: true
    }))));
  }
  return null;
});
export const SharedUiAnsweringTravellerQuestionsWrapper = AnsweringTravellerQuestionsWrapper;
AnsweringTravellerQuestionsWrapper.displayName = 'SharedUiAnsweringTravellerQuestionsWrapper';